// Training packages API — trainer CRUD per client + reminders, and the client
// portal's own package read. Mirrors the sessions.ts shape (http helper).
import { http } from "./http";
import type {
  PackageProgress,
  PackageReminder,
  PackageInput,
  ClientPackageProgress,
} from "./types";

export const packagesApi = {
  listForClient: (clientId: number, signal?: AbortSignal) =>
    http.get<PackageProgress[]>(`/clients/${clientId}/packages`, undefined, signal),
  create: (clientId: number, body: PackageInput) =>
    http.post<PackageProgress>(`/clients/${clientId}/packages`, body),
  get: (packageId: number, signal?: AbortSignal) =>
    http.get<PackageProgress>(`/packages/${packageId}`, undefined, signal),
  update: (packageId: number, body: Partial<PackageInput>) =>
    http.patch<PackageProgress>(`/packages/${packageId}`, body),
  cancel: (packageId: number) =>
    http.post<PackageProgress>(`/packages/${packageId}/cancel`),
  reminders: (signal?: AbortSignal) =>
    http.get<PackageReminder[]>("/packages/reminders", undefined, signal),
  // Client portal realm.
  mine: (signal?: AbortSignal) =>
    http.get<ClientPackageProgress>("/client/me/package", undefined, signal),
};
